import { useForm } from '@tanstack/react-form'
import { useMutation } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { Toast, handleFormSubmissionError } from 'ui/components'
import { InvoiceSubmittalFormRequest, saveInvoice } from '~bank-invoices/service/saveInvoiceSubmittal'
import { InvoiceSubmittalDetails } from '~bank-invoices/types/Details'
import { ManageInvoiceSubmittalFormType } from '~bank-invoices/types/Manage'

import { ManageInvoicePage } from '../../components/ManageInvoicePage'

const routeApi = getRouteApi('/_app/invoices/add')

const CreateInvoice = () => {
  const navigate = routeApi.useNavigate()
  const { licenseId, licenseName, returnUrl } = routeApi.useSearch()
  const appearanceInfo = { licenseId, licenseName }

  const formApi = useForm({
    defaultValues: new ManageInvoiceSubmittalFormType(true),
    onSubmit: async ({ value }) => await saveInvoiceSubmittal({ ...value, licenseId })
  })

  const { mutateAsync: saveInvoiceSubmittal } = useMutation<
    InvoiceSubmittalDetails,
    Error,
    InvoiceSubmittalFormRequest
  >({
    mutationFn: (opts) => saveInvoice(opts),
    onSuccess: async (response) => {
      if (response.id) {
        await navigate({ to: '/invoices/$id', params: { id: response.id.toString() } })
      }
      Toast.successSmall('Invoice created')
    },
    onError: (error) => {
      handleFormSubmissionError<ManageInvoiceSubmittalFormType>(error, formApi)
    }
  })

  const onCancel = () => {
    if (returnUrl) {
      navigate({ to: returnUrl as never })
    } else {
      navigate({ to: '/licenses/$licenseId', params: { licenseId: licenseId.toString() } })
    }
  }

  return (
    <ManageInvoicePage
      pageTitle="New"
      panelTitle="Add New Invoice Submittal Detail"
      formApi={formApi}
      appearanceInfo={appearanceInfo}
      onCancel={onCancel}
    />
  )
}

export default CreateInvoice
